<template>
  <div>
    Under construction...
    <p></p>
    The grid below shows the items you have selected and profile layed out by
    default on one a day over a two week sprint
    <p></p>
    You can move them in time. Vertical scaling shows 'complexity' using the
    clipped Fibonacci series. Horiontal scaling shows time based on an eight
    hour day.
    <p></p>
    <ProfileGroup></ProfileGroup>
    <!-- <Profile></Profile>
  <Scheduler></Scheduler> -->
    <!-- <v-stage ref="stage" :config="stageSize" @mousedown="handleStageMouseDown">
    <v-layer ref="layer">
      <v-rect v-for="item in rectangles" :key="item.id" :config="item" />
      <v-transformer ref="transformer" />
    </v-layer>
  </v-stage> -->
  </div>
</template>

<script>
const width = window.innerWidth;
const height = window.innerHeight;
import Scheduler from "@/components/Scheduler";
import Profile from "@/components/Profile";
import ProfileGroup from "@/components/ProfileGroup";

export default {
  name: "Dates",
  components: { Scheduler, Profile, ProfileGroup }
};
</script>
